import { getDriveId } from '../services/getDriveId';
import { getFileProvider } from 'owa-fileprovider-store';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import {
    resolveODSPDriverInfoForNewFile,
    getFullODSPFileName,
    ODSPNewFileInfo,
} from '@ms/office-web-host';
import { newFileName } from './getDriverInfoForNewFile.locstring.json';
import loc from 'owa-localize';
import type { IFluidCodeDetails } from '@fluidframework/core-interfaces';
import { FluidOwaSource, isChapterTwoScenario } from 'owa-fluid-validations';
import { getSpecialFolderInfo } from '../services/getSpecialFolderInfo';

export async function getDriverInfoForNewFile(
    codeDetails: IFluidCodeDetails,
    owaSource: FluidOwaSource,
    name?: string
) {
    // VSO 83889 support ODC as well
    const providerInfo = getFileProvider(AttachmentDataProviderType.OneDrivePro.toString());
    if (!providerInfo) {
        throw new Error('No provider found to create fluid component');
    }

    const formattedName = isNullOrWhiteSpace(name || '')
        ? ''
        : name!.replace(/[\~\#\%\&\*\{\}\\\:\<\>\?\/\+\|\"\.]/g, '').trim();
    let fileName = isNullOrWhiteSpace(formattedName) ? loc(newFileName) : formattedName;
    // appends extension to the file name
    fileName = getFullODSPFileName(codeDetails, fileName);

    const uploadFolder = isChapterTwoScenario(owaSource) ? 'Meetings' : 'Attachments';

    // Ensure we get the correct special folder name regardless of user modification and/or localization
    const specialFolderInfo: string | undefined = await getSpecialFolderInfo(uploadFolder);
    if (!specialFolderInfo) {
        throw new Error('Could not retrieve special folder info');
    }

    // This needs to be a promise for the owh code to handle it correctly.
    const newFileInfoPromise: Promise<ODSPNewFileInfo> = getDriveId().then(driveId => {
        if (!driveId) {
            throw new Error('No drive id for file creation');
        }
        return <ODSPNewFileInfo>{
            siteUrl: providerInfo.model.EndPointUrl,
            driveId: driveId,
            filename: fileName,
            filePath: specialFolderInfo,
        };
    });
    const driverInfo = resolveODSPDriverInfoForNewFile(newFileInfoPromise);
    return driverInfo;
}
